<script>
import appbarMixin from '@/v-shop/mixins/appbarMixin'

export default {
	mixins: [appbarMixin],
	data() {
		return {
			currentIdx: 0,
			autoplayInterval: null,
			isTransitioning: false,
			currentTranslate: 0,
			slideWidth: 0,
		}
	},
	computed: {
		autoplayDuration() {
			return this.$srv('appbarTopMessage.slideTimer', 4000)
		},
		animationDuration() {
			return this.$srv('appbarTopMessage.animationDuration', 3500)
		},
		showTopAppBar() {
			return this.$srv('AppBarConfig.showTopNavbar', false)
		},
		topMsgConfig() {
			return this.$srv('appbarTopMessage', {})
		},
		slides() {
			const slides = this.$srv('appbarTopMessage.slides', [])
			return [...slides, slides[0], slides[1]].filter(Boolean)
		},
	},
	methods: {
		startAutoplay() {
			this.autoplayInterval = setInterval(this.nextSlide, this.autoplayDuration)
		},
		nextSlide() {
			if (this.isTransitioning) return

			this.isTransitioning = true
			this.currentIdx++
			this.currentTranslate += this.slideWidth

			if (this.currentIdx >= this.slides.length - 2) {
				setTimeout(() => {
					this.currentIdx = 0
					this.currentTranslate = 0
					this.isTransitioning = false
				}, this.animationDuration)
			} else {
				setTimeout(() => {
					this.isTransitioning = false
				}, this.animationDuration)
			}
		},
		handleVisibilityChange() {
			if (document.hidden) {
				this.stopAutoplay()
				this.autoplayInterval = null
			} else if (!this.autoplayInterval) {
				this.startAutoplay()
			}
		},
		stopAutoplay() {
			if (this.autoplayInterval) {
				clearInterval(this.autoplayInterval)
				this.autoplayInterval = null
			}
		},
		onResize() {
			this.stopAutoplay()
			const width = this.$refs.slideContainer.clientWidth
			this.currentTranslate = this.currentIdx * width
			this.slideWidth = width
			this.startAutoplay()
		},
	},
	mounted() {
		if (this.topMsgConfig.useCarousel && this.slides.length > 1) {
			document.addEventListener('visibilitychange', this.handleVisibilityChange) // handle browser tab visibility change
			window.addEventListener('resize', this.onResize)
			this.slideWidth = this.$refs.slideContainer.clientWidth
			this.startAutoplay()
		}
	},
	beforeDestroy() {
		this.stopAutoplay()
		window.removeEventListener('resize', this.resize)
		document.removeEventListener('visibilitychange', this.handleVisibilityChange)
	},
}
</script>

<template>
	<div
		v-if="$b.d && showTopAppBar"
		ref="slideContainer"
		class="appbar-top-msg secondary d-flex align-center"
	>
		<div
			v-if="topMsgConfig.useCarousel && slides.length > 1"
			class="w100 secondary d-flex align-center"
			:style="{
				transform: `translateX(-${currentTranslate}px)`,
				transition: isTransitioning ? `transform ${animationDuration}ms ease-in-out` : 'none',
			}"
		>
			<AppBar-TopMsg-Item
				v-for="(slide, n) in slides"
				:key="n"
				class="appbar-top-msg__content w100 flex-shrink-0"
				:slide="slide"
			/>
		</div>
		<AppBar-TopMsg-Item v-else class="w100" :slide="topMsgConfig" />
	</div>
</template>

<style scoped lang="scss">
.appbar-top-msg {
	transition: transform 3.5s ease-in-out;
}
</style>

